import React from 'react';
import { useTranslations } from '../utils/translations';
import illustrationImage from '../assets/illustration.png';
import './QuizSlide.css';

const SuccessSlide = ({ currentLanguage, onGoToSlide1, onExit }) => {
  const { t } = useTranslations(currentLanguage);

  return (
    <div className="completion-screen" style={{ backgroundImage: `url(${illustrationImage})` }}>
      <div className="completion-container">
        <div className="completion-icon success-icon">
          🎉
        </div>
        
        <div className="completion-content">
          <div className="final-completion">
            <p className="completion-message">
              {t('ui.quiz.finalCompletion')}
            </p>
            <p className="completion-sub-message">
              {t('ui.quiz.thankYou')}
            </p>
          </div>
        </div>
        
        <div className="completion-actions">
          <button className="completion-btn completion-btn-secondary" onClick={onGoToSlide1}>
            {t('ui.navigation.goToSlide1')}
          </button>
          <button className="completion-btn completion-btn-secondary" onClick={onExit}>
            {t('ui.navigation.exit')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessSlide;
